import { useState } from "react";

import { CollapseTransition, FilterBarHeaderActions } from "@impero-com/ui";
import { MenuProps } from "antd";

import * as theme from "./DashboardFilterBar.css";

interface DashboardFilterBarProps {
    children: React.ReactNode;
    addLabel: string;
    hideFiltersLabel: string;
    getFilterCountLabel: (filterCount: number) => string;
    addFilterItems: MenuProps["items"];
    filterCount: number;
    onClearFilters: () => void;
    clearable?: boolean;
    /** Controlled collapsed state. Pair with onCollapsedChange; omit for uncontrolled. */
    collapsed?: boolean;
    onCollapsedChange?: (collapsed: boolean) => void;
}
export function DashboardFilterBar({
    children,
    addLabel,
    getFilterCountLabel,
    hideFiltersLabel,
    filterCount,
    addFilterItems,
    onClearFilters,
    clearable,
    collapsed,
    onCollapsedChange,
}: DashboardFilterBarProps) {
    const [internalHidden, setInternalHidden] = useState(false);

    const isControlled = collapsed !== undefined && !!onCollapsedChange;
    const isHidden = isControlled ? collapsed : internalHidden;
    const setIsHidden = isControlled ? onCollapsedChange : setInternalHidden;

    return (
        <div className={theme.root}>
            <div className={theme.topRow}>
                <FilterBarHeaderActions
                    isHidden={isHidden}
                    setIsHidden={setIsHidden}
                    addLabel={addLabel}
                    addFilterItems={addFilterItems}
                    hideFiltersLabel={hideFiltersLabel}
                    getFilterCountLabel={getFilterCountLabel}
                    filterCount={filterCount}
                    rowCountLabel={undefined}
                    onClearFilters={onClearFilters}
                    clearable={clearable}
                    hasFilters={true} // TODO sc-38655 To be addressed in the alignment story how we count the filters and reset them
                />
            </div>

            <CollapseTransition collapsed={isHidden}>
                {children}
            </CollapseTransition>
        </div>
    );
}
